/** TODO temporary. will be refactored */

import { SecurityScope } from '../auth/auth.model';
import { createAction } from '../store.model';

import {
    AreaItem,
    LobItem,
    RegionItem,
    RoleItem,
    SiteItem,
    SuperGroupItem,
} from './core';
import { Column, Row } from './experimental.grid';
import { CriteriaFormValue } from './search-user.form';
import { UserSearchResult } from './search-user.model';
import { User } from './user.model';

export enum ActionType {
    SEARCH_USER__ROOT__INIT = 'SEARCH_USER__ROOT__INIT',
    SEARCH_USER__ROOT__INIT_RESULT = 'SEARCH_USER__ROOT__INIT_RESULT',
    SEARCH_USER__ROOT__LIST_LOOKUPS = 'SEARCH_USER__ROOT__LIST_LOOKUPS',
    SEARCH_USER__ROOT__LIST_LOOKUPS_RESULT = 'SEARCH_USER__ROOT__LIST_LOOKUPS_RESULT',
    SEARCH_USER__ROOT__CHANGE_CRITERIA = 'SEARCH_USER__ROOT__CHANGE_CRITERIA',
    SEARCH_USER__ROOT__SEARCH = 'SEARCH_USER__ROOT__SEARCH',
    SEARCH_USER__ROOT__SEARCH_RESULT = 'SEARCH_USER__ROOT__SEARCH_RESULT',
    SEARCH_USER__ROOT__SEARCH_CANCEL = 'SEARCH_USER__ROOT__SEARCH_CANCEL',
    SEARCH_USER__ROOT__SELECT_USER = 'SEARCH_USER__ROOT__SELECT_USER',
    SEARCH_USER__ROOT__SELECT_USER_RESULT = 'SEARCH_USER__ROOT__SELECT_USER_RESULT',
    SEARCH_USER__ROOT__TOGGLE_FAVORITE = 'SEARCH_USER__ROOT__TOGGLE_FAVORITE',
    SEARCH_USER__ROOT__TOGGLE_FAVORITE_RESULT = 'SEARCH_USER__ROOT__TOGGLE_FAVORITE_RESULT',
    SEARCH_USER__ROOT__RESET = 'SEARCH_USER__ROOT__RESET',

    SEARCH_USER__GRID__SORT = 'SEARCH_USER__GRID__SORT',
    SEARCH_USER__ROOT__CLEAR_STATE = 'SEARCH_USER__ROOT__CLEAR_STATE',
}

export interface RootInitAction {
    selectedUserId: number;
    scope: SecurityScope;

    /** TODO revise. this is temporary means of flushing tabs after auth user has changed */
    authUserId: number;
}

export const rootInit = createAction<ActionType, RootInitAction>(
    ActionType.SEARCH_USER__ROOT__INIT,
);

export interface RootInitResultAction extends RootInitAction {
    teamColumns?: Column[];
    teamRows?: Row[];
    favoritesColumns?: Column[];
    favoritesRows?: Row[];
    selectedUserProfile?: User;
    selectedUser?: UserSearchResult;
    selectedUserManager?: UserSearchResult;
}

export const rootInitResult = createAction<ActionType, RootInitResultAction>(
    ActionType.SEARCH_USER__ROOT__INIT_RESULT,
);

/// //////////////////////

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface RootListLookupsAction {}

/** separate from init() action to not wait for lookups */
export const rootListLookups = createAction<ActionType, RootListLookupsAction>(
    ActionType.SEARCH_USER__ROOT__LIST_LOOKUPS,
);

export interface RootListLookupsResultAction extends RootListLookupsAction {
    lobs?: LobItem[];
    regions?: RegionItem[];
    areas?: AreaItem[];
    sites?: SiteItem[];
    superGroups?: SuperGroupItem[];
    roles?: RoleItem[];
}

export const rootListLookupsResult = createAction<
    ActionType,
    RootListLookupsResultAction
>(ActionType.SEARCH_USER__ROOT__LIST_LOOKUPS_RESULT);

/// //////////////////////

export interface RootChangeCriteriaAction {
    criteria: CriteriaFormValue;
}

export const rootChangeCriteria = createAction<
    ActionType,
    RootChangeCriteriaAction
>(ActionType.SEARCH_USER__ROOT__CHANGE_CRITERIA);

/// //////////////////////

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface RootSearchAction {}

export const rootSearch = createAction<ActionType, RootSearchAction>(
    ActionType.SEARCH_USER__ROOT__SEARCH,
);

export interface RootSearchResultAction extends RootSearchAction {
    searchFailed?: boolean;
    searchExceedsMaxCount?: boolean;
    columns?: Column[];
    rows?: Row[];
}

export const rootSearchResult = createAction<
    ActionType,
    RootSearchResultAction
>(ActionType.SEARCH_USER__ROOT__SEARCH_RESULT);

export interface RootSearchCancelAction extends RootSearchAction {}

export const rootSearchCancel = createAction<
    ActionType,
    RootSearchCancelAction
>(ActionType.SEARCH_USER__ROOT__SEARCH_CANCEL);

/// //////////////////////

export interface RootSelectUserAction {
    userId: number;
}

export const rootSelectUser = createAction<ActionType, RootSelectUserAction>(
    ActionType.SEARCH_USER__ROOT__SELECT_USER,
);

export interface RootSelectUserResultAction extends RootSelectUserAction {
    userProfile?: User;
    user?: UserSearchResult;
    manager?: UserSearchResult;
    teamRows?: Row[];
}

export const rootSelectUserResult = createAction<
    ActionType,
    RootSelectUserResultAction
>(ActionType.SEARCH_USER__ROOT__SELECT_USER_RESULT);

/// //////////////////////

export interface RootToggleFavoriteAction {
    user: UserSearchResult;
    refId: string;
}

export const rootToggleFavorite = createAction<
    ActionType,
    RootToggleFavoriteAction
>(ActionType.SEARCH_USER__ROOT__TOGGLE_FAVORITE);

export interface RootToggleFavoriteResultAction
    extends RootToggleFavoriteAction {
    favoritesRows?: Row[];
    selectedUser?: UserSearchResult;
}

export const rootToggleFavoriteResult = createAction<
    ActionType,
    RootToggleFavoriteResultAction
>(ActionType.SEARCH_USER__ROOT__TOGGLE_FAVORITE_RESULT);

/// //////////////////////

export interface RootResetAction {
    /** TODO revise. this is temporary means of flushing tabs after auth user has changed */
    hard?: boolean;
}

/** this doesn't cancel pending requests */
export const rootReset = createAction<ActionType, RootResetAction>(
    ActionType.SEARCH_USER__ROOT__RESET,
);

/// //////////////////////

export interface GridSortAction {
    column?: Column;
}

export const gridSort = createAction<ActionType, GridSortAction>(
    ActionType.SEARCH_USER__GRID__SORT,
);

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface RootClearStateAction {}

export const rootClearState = createAction<ActionType, RootClearStateAction>(
    ActionType.SEARCH_USER__ROOT__CLEAR_STATE,
);
